<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->
<div class="loader">
  <app-loading-spinner [loadable$]="loading$"></app-loading-spinner>
</div>

<app-data-table-footer *ngIf="displayPagination"
                       [rowCount]="_rowCount"
                       [pageSize]="limit"
                       [nextDisabled]="currentPageNumber === _maxPageNumber"
                       [backDisabled]="currentPageNumber === 0"
                       [displaySearch]="displaySearch"
                       [paginationPage]="currentPageNumber"
                       (paginationChange)="updatePagination($event,'')"
                       (searchValues)="searchValues($event)">
</app-data-table-footer>

<ngx-datatable #myTable
               class='material expandable'
               [columns]="columns"
               [columnMode]="columnMode"
               [limit]="limit"
               [offset]="currentPageNumber"
               [rowIdentity]="rowIdentity"
               [rows]="_rows"
               [rowHeight]="undefined"
               [selectionType]="selectionType"
               [selected]="selectedItems"
               [headerHeight]="50"
               (select)="selectRow($event)"
               (sort)="resetPagination()">

  <ngx-datatable-row-detail [rowHeight]="undefined"
                            #myDetailRow>
    <ng-template let-row="row"
                 let-expanded="expanded"
                 ngx-datatable-row-detail-template>
      <div class="row-detail">
        <ng-container *ngTemplateOutlet="template; context: { $implict: row, row: row, index: i }"></ng-container>
      </div>
    </ng-template>
  </ngx-datatable-row-detail>

  <ngx-datatable-column *ngIf="extendRow"
                        [width]="50"
                        [resizeable]="false"
                        [sortable]="false"
                        [draggable]="false"
                        [canAutoResize]="false">
    <ng-template let-row="row"
                 let-expanded="expanded"
                 ngx-datatable-cell-template>
      <a href="javascript:void(0)"
         [class.datatable-icon-right]="!expanded"
         [class.datatable-icon-down]="expanded"
         title="Expand/Collapse Row"
         (click)="$event.preventDefault(); $event.stopPropagation();toggleExpandRow(row)">
        <i class="material-icons">keyboard_arrow_down</i>
      </a>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column *ngIf="selectionType ==='multiClick'"
                        [width]="40"
                        [sortable]="false"
                        [canAutoResize]="false"
                        [draggable]="false"
                        [resizeable]="false"
                        [prop]="selectedItemKey"
                        name="">
    <ng-template ngx-datatable-cell-template
                 let-row="row"
                 let-isSelected="isSelected">
      <div class="custom-control custom-checkbox readonly">
        <input class="custom-control-input d-none"
               type="checkbox"
               id="chck-{{ row[selectedItemKey] }}"
               [checked]="isSelected" />
        <input *ngIf="isExcludedRow(row)" class="custom-control-input d-none"
               type="checkbox"
               id="chck-{{ row[selectedItemKey] }}"
               checked="true" disabled/>
        <label class="custom-control-label mb-3"></label>
      </div>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column *ngFor="let col of columns; trackBy: trackColumns"
                        [name]="col.name"
                        [prop]="col.prop"
                        [cellClass]="col.cellClass"
                        [cellTemplate]="col.cellTemplate"
                        [pipe]="col.pipe"
                        [flexGrow]="col.flexGrow">
  </ngx-datatable-column>

</ngx-datatable>


// WEBPACK FOOTER //
// ./src/app/shared/data-table-ajax/data-table-ajax.component.html